<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
      @if (subscription()) {
      <ion-button (click)="delete()">
        <ion-icon name="trash-outline" slot="icon-only" size="small"></ion-icon>
      </ion-button>
      }
    </ion-buttons>
    <ion-title>Abo</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.subscriptionForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="subscriptionForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item-divider>
        <ion-label>Preis</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-note slot="start">
          <ion-icon color="primary" name="car-outline" class="-mt-1 text-lg"></ion-icon>
        </ion-note>
        <ion-input
          label="Lektionen"
          formControlName="lessons"
          placeholder="Anzahl Lektionen"
          type="number"
          (input)="updateForm()"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="CHF "
          type="number"
          formControlName="prize"
          placeholder="Preis"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item-divider>
        <ion-label>Info</ion-label>
      </ion-item-divider>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="document-text-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input formControlName="name" placeholder="Bezeichnung"></ion-input>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
